export function dualStatusDisclosureRealEstateBrokerandMLO2027() {
return [   // Release 2026-10-05 13:02:36
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 277.92,
   left: 63.0,
   width: 354.0,
   height: 14.40
}
,
{
   page: 0,
   name: "Checkbox Broker is acting in dual capacity", 
   isText: false,
   type: "checkbox",
   top: 379.273,
   left: 126.492,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Broker is not acting in dual capacity", 
   isText: false,
   type: "checkbox",
   top: 378.618,
   left: 156.601,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Broker is accepting placement fee", 
   isText: false,
   type: "checkbox",
   top: 393.673,
   left: 263.947,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Broker is not accepting placement fee", 
   isText: false,
   type: "checkbox",
   top: 393.673,
   left: 292.747,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 447.295,
   left: 170.88,
   width: 360.00,
   height: 13.745
}
,
{
   page: 0,
   name: "Checkbox Buyer does consent to dual capacity", 
   isText: false,
   type: "checkbox",
   top: 464.404,
   left: 62.837,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Buyer does not consent to dual capacity", 
   isText: false,
   type: "checkbox",
   top: 468.332,
   left: 115.856,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Buyer does consent to broker receiving placement fee", 
   isText: false,
   type: "checkbox",
   top: 516.441,
   left: 175.747,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Buyer does not consent to broker receiving placement fee", 
   isText: false,
   type: "checkbox",
   top: 517.423,
   left: 222.875,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Date Broker Provided", 
   fontSize: 9,
   type: "date",
   top: 341.48,
   left: 93.96,
   width: 150.00,
   height: 12.72
}
,
{
   page: 1,
   name: "Buyers Legal Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 362.48,
   left: 72.0,
   width: 468.0,
   height: 12.36
}
,
{
   page: 1,
   name: "how doc provided", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 384.189,
   left: 321.96,
   width: 156.00,
   height: 11.411
}
,
{
   page: 1,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 478.171,
   left: 72.0,
   width: 258.0,
   height: 14.029
}
] }
